/* eslint-disable max-len */
export default {
    ADD_TO_CART: '장바구니에 추가',
    ADD_TO_WISHLIST: '위시리스트에 저장',
    APPLY: '적용',
    CALL_US: '문의하기',
    CANCEL: '취소하기',
    CHOOSE_OPTION: '옵션 선택',
    COMPLETED: '디자인 완성',
    COMPONENTS: 'Selections',
    COPY: '디자인 링크 복사하기',
    COPIED: '클립보드에 복사된 링크',
    CUSTOMER_SERVICE: '고객센터에 문의해보세요!',
    DETAILS: '상세보기',
    DIFFERENT_SIZE: '왼발, 오른발 다른 사이즈를 원하시나요?',
    DONE_FOR_NOW: '마이조이를 끝내시겠습니까?',
    EMAIL: '이메일 전송하기',
    EMAIL_DESIGN: '이메일 전송하기',
    EMAIL_INVALID: '이메일 주소를 입력해주세요.',
    EMAIL_SENT: '감사합니다! 디자인하신 마이조이 링크가 전송되었습니다.',
    EMAIL_SUMMARY: '마이조이 : 이메일 요약',
    ENTER_EMBROIDERY: '커스텀 자수 입력하기',
    HELP: '도움이 필요하신가요?',
    HOURS: '오전 9시 ~ 오후 6시 (월~금)',
    INVALID_ERROR: '올바른 형식이 아닙니다',
    MAKE_A_SELECTION: '원하는 디자인을 선택하세요',
    MAX_LENGTH_6: '가능한 글자 수 6',
    MAX_LENGTH_3: '가능한 글자 수 3',
    MENS: '남성',
    MESSAGE: '메세지',
    MESSAGE_US: '문의하기',
    NEED_HELP: '도움이 필요하세요?',
    NONE_SELECTED: '색상 다시 선택',
    OK: 'Ok',
    PERSONALIZATION_POLICY: '사용안내',
    PHONE_NUMBER: '0261913993',
    PHONE_NUMBER_FORMATTED: '02-6191-3993',
    PRINT: '프린트하기',
    RECIPIENT_NAME: '수령인의 이름',
    RECIPIENT_EMAIL: '수령인의 이메일 주소',
    REQUIRED: '필수 항목입니다.',
    RESET: '초기화하기',
    RESET_CONFIRM: '마이조이 디자인을 초기화하시겠어요?',
    RESET_CONFIRM_COPY: '모든 디자인 설정이 초기화되며 디자인을 처음부터 다시 시작하실 수 있습니다.',
    SAVE: '저장하기',
    SAVE_EXIT: '저장 후 종료',

    SELECT_SIZE: '사이즈 선택하기',
    SELECT_WIDTH: '볼넓이 선택하기',
    LEFT_SHOE_SIZE: '왼발 사이즈',
    RIGHT_SHOE_SIZE: '오른발 사이즈',

    SEND_COPY: '내게도 이메일 사본 보내기',
    SHARE: '공유하기',
    SHARE_DESIGN: '디자인 공유하기',
    SIZE_GUIDE: '사이즈 가이드',
    SUBMIT: '전송하기',
    UNDO: '되돌아가기',
    VIEW_ALL: '모두보기',
    WEVE_GOT_YOU: '이 페이지를 떠나신다면, 나중에 진행할 수 있도록 지금까지 선택한 마이조이 디자인이 저장됩니다.',
    WOMENS: '여성',
    YOUR_NAME: '이름',
    YOUR_EMAIL: '이메일 주소',
    INSTANCE_ERROR_HEADER: '저장에 실패했습니다.',
    INSTANCE_ERROR_BODY: '저장에 실패했습니다. 다시 시도해주십시오.',
    UPDATE_CART: '장바구니 업데이트',
    PERSONALIZE_CHOOSE_OPTION: '옵션 선택',
    PERSONALIZE_SAME_LEFT: '왼쪽과 동일',
    PERSONALIZE_SAME_RIGHT: '오른쪽과 동일',
    PERSONALIZE_NONE: '없음',
    PERSONALIZE_LOGO: '로고',
    PERSONALIZE_MONOGRAM: '모노그램',
    MONOGRAM_COLOR: '모노그램 컬러',
};
